import { useGetPresentersList } from '@/hooks/presenter';
import { useAgentEditorStore } from '@/state/root';
import { IAgent, PresenterUsecase } from '@d-id/types';
import { useCallback, useEffect } from 'react';
import { loadSavedAgentState } from '../utils';
import { useGetAllVoices } from './useGetAllVoices';

interface Props {
    callback?: (agent: IAgent) => void;
    agent: IAgent;
}

export const useLoadAgentIntoStore = ({ callback, agent }: Props) => {
    const agentEditorStore = useAgentEditorStore();
    const {
        data: presenters,
        isSuccess: arePresentersReady,
        isPlaceholderData: isPresentersPlaceholderData,
    } = useGetPresentersList({ usecase: PresenterUsecase.Agent });

    const voiceOptions = useGetAllVoices();
    const voicesLoaded = !!Object.keys(voiceOptions).length;

    const loadIntoStore = useCallback(async () => {
        if (!voicesLoaded || isPresentersPlaceholderData || !arePresentersReady) {
            return;
        }

        agentEditorStore.setIsEditingDraftAgent(true);
        await loadSavedAgentState(agent, presenters, voiceOptions);

        return callback?.(agent);
    }, [voicesLoaded, arePresentersReady, isPresentersPlaceholderData]);

    useEffect(() => {
        loadIntoStore();
    }, [loadIntoStore]);
};
